import * as React from 'react'

function SmartphoneGym(props) {
  return (
    <svg width={110} height={64} viewBox="0 0 70 64" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.572 64C67.57 64 70 61.59 70 58.62V5.38C70 2.41 67.569 0 64.572 0H37.09c-2.996 0-5.428 2.41-5.428 5.38v21.714L18.91 23.707l2.959-10.944-8.671-2.303-1.41 5.217-3.433-.911-1.548 5.726-5.203-1.381a1.278 1.278 0 00-1.558.904c-.184.679.216 1.375.893 1.555l5.203 1.382-1.548 5.727 3.432.912-1.41 5.217 8.67 2.303 2.959-10.945 13.417 3.564v28.89c0 2.97 2.432 5.38 5.428 5.38h27.483zM33.68 30.266V56h34.303V8H33.68v19.63l9.544 2.534 2.959-10.944 8.67 2.303-1.41 5.217 3.469.921-1.549 5.727 5.203 1.382c.677.18 1.077.876.894 1.555a1.278 1.278 0 01-1.559.905l-5.203-1.382-1.548 5.727-3.468-.921-1.41 5.217-8.671-2.303 2.958-10.944-8.879-2.358zM64.572 2c1.88 0 3.41 1.516 3.41 3.38V6H33.68v-.62c0-1.864 1.53-3.38 3.41-3.38h27.483zM33.68 58.62V58h34.303v.62c0 1.864-1.53 3.38-3.41 3.38H37.09c-1.88 0-3.41-1.516-3.41-3.38zm19.615-36.193l-5.917 21.889-6.219-1.652 5.917-21.889 6.22 1.652zM52.256 40.02l3.096-11.455-2.206-.586-3.097 11.455 2.207.586zM20.309 13.666l-6.219-1.651-5.917 21.889 6.219 1.652 5.917-21.89zM9.248 16.322l2.206.586L8.357 28.36l-2.206-.586 3.097-11.454z"
        fill="#452562"
      />
    </svg>
  )
}

export default SmartphoneGym
